/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebdaymon3Inputs */

const en_placewebdaymon3 = /** @type {(inputs: Placewebdaymon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon`)
};

const de_placewebdaymon3 = /** @type {(inputs: Placewebdaymon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mo`)
};

/**
* | output |
* | --- |
* | "Mon" |
*
* @param {Placewebdaymon3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebdaymon3 = /** @type {((inputs?: Placewebdaymon3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebdaymon3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebdaymon3(inputs)
	return de_placewebdaymon3(inputs)
});
export { placewebdaymon3 as "placeWebDayMon" }